import React, { useState, useEffect } from "react";
import { usePage } from "@inertiajs/inertia-react";
import {
  CheckCircleIcon,
  XCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/20/solid";

export const NoticeMessage = () => {
  const [showMessage, setShowMessage] = useState(true);
  const [showError, setShowError] = useState(true);
  const [showInfo, setShowInfo] = useState(true);
  const { flash } = usePage().props;

  // Re-show whenever a new flash arrives (Inertia keeps this layout mounted
  // across visits, so a prior dismiss would otherwise hide later notices).
  // flash.id changes on every flash so identical messages still reappear.
  // Scroll to top so the banner is visible after long forms (e.g. Domestic profile).
  useEffect(() => {
    if (flash.message) {
      setShowMessage(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      const timeoutId = setTimeout(() => setShowMessage(false), 10000);
      return () => clearTimeout(timeoutId);
    }
  }, [flash.message, flash.id]);

  useEffect(() => {
    if (flash.error) {
      setShowError(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      const timeoutId = setTimeout(() => setShowError(false), 10000);
      return () => clearTimeout(timeoutId);
    }
  }, [flash.error, flash.id]);

  useEffect(() => {
    if (flash.info) {
      setShowInfo(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      const timeoutId = setTimeout(() => setShowInfo(false), 10000);
      return () => clearTimeout(timeoutId);
    }
  }, [flash.info, flash.id]);

  return (
    <>
      {showError && flash.error && (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 pt-6">
          <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
              </div>
              <div className="ml-3 flex-1 md:flex md:justify-between">
                <p className="text-sm text-red-700">{flash.error}</p>
                <p className="mt-3 text-sm md:mt-0 md:ml-6">
                  <button
                    onClick={() => setShowError(false)}
                    type="button"
                    className="whitespace-nowrap font-medium text-red-700 hover:text-red-600"
                  >
                    Dismiss
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {showInfo && flash.info && (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 pt-6">
          <div className="rounded-md bg-blue-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <InformationCircleIcon
                  className="h-5 w-5 text-blue-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ml-3 flex-1 md:flex md:justify-between">
                <p className="text-sm text-blue-700">{flash.info}</p>
                <p className="mt-3 text-sm md:mt-0 md:ml-6">
                  <button
                    onClick={() => setShowInfo(false)}
                    type="button"
                    className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600"
                  >
                    Dismiss
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      {showMessage && flash.message && (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 pt-6">
          <div className="rounded-md bg-green-50 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <CheckCircleIcon
                  className="h-5 w-5 text-green-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ml-3 flex-1 md:flex md:justify-between">
                <p className="text-sm text-green-700">{flash.message}</p>
                <p className="mt-3 text-sm md:mt-0 md:ml-6">
                  <button
                    onClick={() => setShowMessage(false)}
                    type="button"
                    className="whitespace-nowrap font-medium text-green-700 hover:text-green-600"
                  >
                    Dismiss
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoticeMessage;
